@if (enableLink) {
  @if (openInNewWindow) {
    <a [href]="url" target="_blank">
      {{ linkText }}
    </a>
  } @else {
    <a [attr.href]="url || null" (click)="onLinkClick($event)">
      {{ linkText }}
    </a>
  }
}

@if (!enableLink) {
  {{ linkText }}
}
